import angular from 'angular';
import { cloneDeep } from 'lodash';

const module = angular.module('whyline.components.inputSpinner', []);

const inputSpinnerComponent = {
  bindings: {
    label: '@',
    min: '@',
    max: '@',
    ngModel: '<'
  },
  require: { ngModelCtrl: 'ngModel' },
  templateUrl: '/templates/components/input-spinner.html',
  controller($scope) {
    'ngInject';

    const setModelValue = () => {
      if (!this.ngModelCtrl) {
        return;
      }
      this.ngModelCtrl.$setViewValue($scope.$ctrl.ngModel);
    }

    $scope.increaseEntries = () => {
      const max = parseInt($scope.$ctrl.max);
      const min = parseInt($scope.$ctrl.min);
      if(max <= min){
        $scope.$ctrl.ngModel = min;
        setModelValue();
        return;
      }
      if($scope.$ctrl.ngModel >= max){
        $scope.$ctrl.ngModel = max;
        setModelValue();
        return;
      }
      $scope.$ctrl.ngModel++;
      setModelValue();
    }
  
    $scope.decreaseEntries = () => {
      const min = parseInt($scope.$ctrl.min);
      if($scope.$ctrl.ngModel <= min){
        $scope.$ctrl.ngModel = min;
        setModelValue();
        return;
      }
      $scope.$ctrl.ngModel--;
      setModelValue();
    }

    $scope.onChangeModel = () => {
      setModelValue();
    }
  },
};

module.exports = module.component('inputSpinner', inputSpinnerComponent);